'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_auth$package$AppAuthError$() {
  this.Lapp_data_auth$package$AppAuthError$__f_defaultMake$lzy1 = null;
  this.Lapp_data_auth$package$AppAuthError$__f_defaultMakebitmap$1 = false;
  this.Lapp_data_auth$package$AppAuthError$__f_make$lzy1 = null;
  this.Lapp_data_auth$package$AppAuthError$__f_makebitmap$1 = false;
}
export { $c_Lapp_data_auth$package$AppAuthError$ as $c_Lapp_data_auth$package$AppAuthError$ };
$c_Lapp_data_auth$package$AppAuthError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_auth$package$AppAuthError$.prototype.constructor = $c_Lapp_data_auth$package$AppAuthError$;
/** @constructor */
function $h_Lapp_data_auth$package$AppAuthError$() {
}
export { $h_Lapp_data_auth$package$AppAuthError$ as $h_Lapp_data_auth$package$AppAuthError$ };
$h_Lapp_data_auth$package$AppAuthError$.prototype = $c_Lapp_data_auth$package$AppAuthError$.prototype;
$c_Lapp_data_auth$package$AppAuthError$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_auth$package$AppAuthError$__f_defaultMakebitmap$1)) {
    this.Lapp_data_auth$package$AppAuthError$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_auth$package$AppAuthError$__f_defaultMakebitmap$1 = true;
  }
  return this.Lapp_data_auth$package$AppAuthError$__f_defaultMake$lzy1;
});
$c_Lapp_data_auth$package$AppAuthError$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_auth$package$AppAuthError$__f_makebitmap$1)) {
    this.Lapp_data_auth$package$AppAuthError$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_auth$package$AppAuthError$__f_makebitmap$1 = true;
  }
  return this.Lapp_data_auth$package$AppAuthError$__f_make$lzy1;
});
$c_Lapp_data_auth$package$AppAuthError$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_auth$package$AppAuthError$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_auth$package$AppAuthError$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_auth$package$AppAuthError$.prototype.validate__Lyantl_Validate = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validate$().Lyantl_Validate$__f_noOp;
});
var $d_Lapp_data_auth$package$AppAuthError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_auth$package$AppAuthError$, "app.data.auth$package$AppAuthError$", ({
  Lapp_data_auth$package$AppAuthError$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lyantl_Newtype$WithoutValidation: 1
}));
export { $d_Lapp_data_auth$package$AppAuthError$ as $d_Lapp_data_auth$package$AppAuthError$ };
var $n_Lapp_data_auth$package$AppAuthError$;
function $m_Lapp_data_auth$package$AppAuthError$() {
  if ((!$n_Lapp_data_auth$package$AppAuthError$)) {
    $n_Lapp_data_auth$package$AppAuthError$ = new $c_Lapp_data_auth$package$AppAuthError$();
  }
  return $n_Lapp_data_auth$package$AppAuthError$;
}
export { $m_Lapp_data_auth$package$AppAuthError$ as $m_Lapp_data_auth$package$AppAuthError$ };
//# sourceMappingURL=app.data.auth$package$-App-Auth-Error$.js.map
